<mat-toolbar class="fixed z-10 bg-white shadow-md items-end toolbar-header" [ngClass]="{ 'w-sub-header': (currentUser | async) }">
  @if (isPhoneOrTablet$ | async) {
    <button class="mr-2" type="button" (click)="toggleNav()" aria-label="Toggle Side Navigation" mat-button-icon>
      <mat-icon class="mt-2" aria-label="Side Navigation Icon">menu</mat-icon>
    </button>
  }

  <div class="flex flex-col w-full">
    <div class="flex main-header">
      <a class="ml-2" [routerLink]="logoLink">
        <img src="/assets/qb-logo-dark.svg" alt style="height: 1.75rem" />
      </a>
      @if ((isPhoneOrTablet$ | async) === false) {
        <qb-navigation-menu class="justify-center flex-1"></qb-navigation-menu>
      }

      @if (currentUser | async; as currentUser) {
        <button mat-raised-button color="clear" [matMenuTriggerFor]="menu" aria-label="User Options">
          <mat-icon id="account-icon">account_circle</mat-icon>
          <span id="contact-name" class="ml-1 text-sm smd:hidden">{{ currentUser.contactInfo.fullName }}</span>
        </button>
        <mat-menu #menu="matMenu">
          <button mat-menu-item routerLink="/settings">
            <mat-icon>settings</mat-icon>
            <span>Account Settings</span>
          </button>
          <button mat-menu-item (click)="onLogout()">
            <mat-icon>logout</mat-icon>
            <span>Log Out</span>
          </button>
        </mat-menu>
      } @else {
        <button mat-raised-button color="clear" type="button" (click)="signUp()">Sign Up</button>
        <button mat-raised-button color="clear" type="button" (click)="login()">Log In</button>
      }
    </div>
    @if (isAuthenticated$ && (isPhoneOrTablet$ | async) === false) {
      <div class="flex items-center sub-header" [ngClass]="{ 'sub-header-cupccaa': isCupccaa | async }">
        <qb-subnav-menu class="flex-1 text-white"></qb-subnav-menu>
        <div class="text-sm text-white">{{ titleText }}</div>
      </div>
    }
  </div>
</mat-toolbar>
